const environment = import.meta.env.VITE_ENVIRONMENT.trim();

const API_IEP_URI  = environment === "production" || environment === "local" ? import.meta.env.VITE_API_IEP_URI : import.meta.env.VITE_API_IEP_URI_TEST;

const config = {
  isLocal: environment === "local",
  isDebug: environment === "local" || environment === "development",

  apiCredentialsUri: `${API_IEP_URI}/auth/sas`,
  apiAccessUri:`${API_IEP_URI}/page_access`,
  apiErrorReportUri: `${API_IEP_URI}/errorreport`,
  apiGetPlatformStatusUri: `${API_IEP_URI}/getplatformstatus`,
  apiSetPlatformStatusUri: `${API_IEP_URI}/setplatformstatus`,
  apiIepUri: `${API_IEP_URI}`,
};

export const helpUrls = {
};

export default config;
